export default __webpack_public_path__ + "static/media/talk.7f4d36dd.png";